import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon/index.js';
import { optionPropType } from './dropdownPropTypes.js';
import { SelectedCount, SelectedItemsHiddenReference } from './Dropdown.styles.js';
import useRect from '../../../hooks/useRect.js';
import { CloseWrapper } from '../../Chip/Chip.styles.js';
import Checkbox from '../Checkbox/index.js';
import { c as components } from '../../../node_modules/react-select/dist/index-a301f526.esm.js';

var _excluded = ["data"],
  _excluded2 = ["getValue", "index", "children"],
  _excluded3 = ["ref"];
var MultiOption = function MultiOption(_ref) {
  var _ref$data = _ref.data,
    data = _ref$data === void 0 ? undefined : _ref$data,
    rest = _objectWithoutProperties(_ref, _excluded);
  return React__default.createElement(components.Option, rest, React__default.createElement(Checkbox, {
    checked: rest.isSelected,
    id: "".concat(data.value),
    label: data.label,
    onChange: function onChange() {},
    size: "small"
  }));
};
var MultiValue = function MultiValue(_ref2) {
  var _ref2$getValue = _ref2.getValue,
    getValue = _ref2$getValue === void 0 ? function () {} : _ref2$getValue,
    _ref2$index = _ref2.index,
    index = _ref2$index === void 0 ? 0 : _ref2$index,
    _ref2$children = _ref2.children,
    children = _ref2$children === void 0 ? undefined : _ref2$children,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var selectedOptions = getValue();
  var selectedTotal = selectedOptions.length;
  var _useRect = useRect(undefined, [selectedTotal]),
    _useRect2 = _slicedToArray(_useRect, 2),
    hiddenItemsRef = _useRect2[0],
    hiddenItemsRect = _useRect2[1];
  var _rest$selectProps = rest.selectProps,
    displayMultiValueItems = _rest$selectProps.displayMultiValueItems,
    setMultiSelectContainerWidth = _rest$selectProps.setMultiSelectContainerWidth,
    selectedChipText = _rest$selectProps.selectedChipText;
  useLayoutEffect(function () {
    if (hiddenItemsRect.width !== 0) {
      setMultiSelectContainerWidth(hiddenItemsRect.width);
    }
  }, [hiddenItemsRect.width]);
  return React__default.createElement(React__default.Fragment, null, displayMultiValueItems ? index === 0 && React__default.createElement(SelectedCount, null, "".concat(selectedTotal, " ").concat(selectedChipText)) : React__default.createElement(components.MultiValue, rest, children), React__default.createElement(SelectedItemsHiddenReference, {
    ref: hiddenItemsRef,
    className: "hiddenReference"
  }, selectedOptions.map(function (option) {
    return React__default.createElement(components.MultiValue, _extends({
      key: option.value
    }, rest), option.label);
  })));
};
var ClearButton = function ClearButton() {
  return React__default.createElement(Icon, {
    variant: "Close",
    size: "tiny"
  });
};
var ClearIndicator = function ClearIndicator(props) {
  var _props$children = props.children,
    children = _props$children === void 0 ? React__default.createElement(ClearButton, null) : _props$children,
    _props$innerProps = props.innerProps,
    ref = _props$innerProps.ref,
    restInnerProps = _objectWithoutProperties(_props$innerProps, _excluded3);
  return React__default.createElement(CloseWrapper, _extends({}, restInnerProps, {
    ref: ref
  }), children);
};
var MultiValueRemove = function MultiValueRemove(props) {
  return React__default.createElement(components.MultiValueRemove, props, React__default.createElement(ClearButton, null));
};
var MultiValueLabel = function MultiValueLabel(_ref3) {
  var children = _ref3.children;
  return children;
};
MultiOption.propTypes = {
  data: optionPropType
};
MultiValue.propTypes = {
  children: PropTypes.node,
  getValue: PropTypes.func,
  index: PropTypes.number
};
MultiValueLabel.propTypes = {
  children: PropTypes.node
};
MultiValueLabel.defaultProps = {
  children: undefined
};
ClearIndicator.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object
};

export { ClearIndicator, MultiOption, MultiValue, MultiValueLabel, MultiValueRemove };
//# sourceMappingURL=Dropdown.multiSelect.js.map
